import axios from "axios";
import { getAdminToken } from "../helpers";
import { baseUrl } from '../../common/constants'

axios.defaults.headers.common['Authorization'] = `${getAdminToken()}`;

const api = axios.create({
  baseURL: baseUrl,
});

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('token');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

const _axios = {
    get: async (url, headers = {}) => {
        return api.get(url, { headers });
    },
    put: async (url, data = {}, options = {}) => {
        return api.put(url, data, options);
    },
    post: async (url, data = {}, options = {}) => {
        return api.post(url, data, options);
    },
    delete: async (url, data = {}, options = {}) => {
        return api.delete(url, data, options);
    }
}

export default _axios;